import { ApiClientBase } from "./ApiClientBase";

class SystemService extends ApiClientBase {
    constructor() {
        super("/api/System/");
    }

    public Version() {
        return this.get<string>(`Version`);
    }
}

export const systemService = new SystemService();
